const statusActionModalFilter = {
  progress: 'En proceso',
  overdue: 'Vencido',
  completed: 'Concluido',
  canceled: 'Cancelado'
};

export default statusActionModalFilter;
